exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#qrcode1 canvas,#qrcode2 canvas,#qrcode3 canvas,#qrcode4 canvas,#qrcode5 canvas,#qrcode6 canvas{display:none!important}#qrcode1 img,#qrcode2 img,#qrcode3 img,#qrcode4 img,#qrcode5 img,#qrcode6 img{width:100px}", ""]);

// exports
